import { render, staticRenderFns } from "./ApmsRegCanteenPurchase.vue?vue&type=template&id=19894356&scoped=true&"
import script from "./ApmsRegCanteenPurchase.vue?vue&type=script&lang=js&"
export * from "./ApmsRegCanteenPurchase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19894356",
  null
  
)

export default component.exports